import { TMutation, TQuery } from 'app/Requests/types';
import httpDriver from 'app/utils/httpDriver';
import { apiRoutes, URI_PREFIX } from 'trends/utils/apiRoutes';
import { apiRoutes as hashtagsApiRoutes } from 'hashtags/utils/apiRoutes';

export const resyncAllHashtags = async (): Promise<any> => {
  const { data } = await httpDriver.post(
    hashtagsApiRoutes().resyncAllHashtags,
    {}
  );
  return data;
};

export const loadHashtagsList = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    hashtagsApiRoutes().TrendingHashtagAutoComplete,
    {
      time_interval: queryKey[1].time_interval,
      limit: 5,
    }
  );
  return data?.payload?.records?.map((item: any) => ({
    label: item.hashtag_name,
    value: item.id,
  }));
};

export const handleGetHeaderInfo = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    `${URI_PREFIX}/${queryKey[1]?.slug}`,
    queryKey[1]?.body
  );
  return data?.payload?.records;
};

export const loadSources = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().sources, {});
  return data?.payload?.records?.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));
};

export const handleCompareHashtags = async ({
  body,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    hashtagsApiRoutes().compareHashtags,
    body
  );
  return data;
};

export const loadTotalPosts = async ({
  body,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    hashtagsApiRoutes().compareHashtagsTotalPosts,
    body
  );
  return data;
};

export const loadSentiment = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    hashtagsApiRoutes().sentimentAnalysis,
    body
  );
  return data;
};

export const resyncHashtag = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    hashtagsApiRoutes().regrabHashtag,
    body
  );
  return data;
};

export const loadTopicView = async ({ queryKey }: TQuery): Promise<any> => {
  const { id, body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes().loadTopicView, {
    topic_id: id,
    ...body,
  });
  return data?.payload?.records;
};

export const loadTopicsOverCountry = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { id, body } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes().topicsCountryDetails, {
    topic_id: id,
    ...body,
  });
  return data?.payload?.records;
};
export const getNewsArticleDetails = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { id } = queryKey[1];
  const { data } = await httpDriver.post(apiRoutes().getNewsArticleDetails, {
    news_id: +id,
  });
  return data?.payload?.records;
};
